import { render, staticRenderFns } from "./LegalDutyAnotherPersonFS.vue?vue&type=template&id=429b5ce3&scoped=true"
import script from "./LegalDutyAnotherPersonFS.vue?vue&type=script&lang=ts"
export * from "./LegalDutyAnotherPersonFS.vue?vue&type=script&lang=ts"
import style0 from "./LegalDutyAnotherPersonFS.vue?vue&type=style&index=0&id=429b5ce3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429b5ce3",
  null
  
)

export default component.exports